<template>
    <div class="share-box">
        <ul :class="centerLayout ? 'center' : ''" >
            <li>
                <a :href="`mailto:?subject=${emailConfig.title}&body=${currentUrl}`"> <img src="https://visionplus.oss-cn-shanghai.aliyuncs.com/nav/news/share-email-icon.svg" alt="VISION+"></a>
            </li>
            <li>
                <i @click="copyLink"><img src="https://visionplus.oss-cn-shanghai.aliyuncs.com/nav/news/share-link-icon.svg" alt="VISION+"></i>
            </li>
        </ul>
        <h2 v-if="hasTitle" :class="centerLayout ? 'center' : ''" >แบ่งปันบทความ</h2>

    </div>
</template>

<script>

    export default {
        props: {
            hasTitle: {
                type: Boolean
            },
            emailConfig: {
                type:  Object,
            },
            centerLayout: {
                type:  Boolean,
            },
        },
        data() {
            return{
                currentUrl: window.location.href
            }
        },
        methods:{
            copyLink() {
                this.$copyText(window.location.href).then(()=>{
                    this.$message({
                        message: 'Copy succeeded',
                        type: 'success',
                        duration: 1500
                    });
                }, () => {
                    this.$message({
                        message: 'Copied to clipboard',
                        type: 'error',
                        duration: 1500
                    });
                })
            },
        },
    }
</script>

<style lang="scss">
    .share-box{
        position: relative;
        // max-width: 800PX;
        margin: 0 auto;
        h2{
            font-size: 20PX;
            line-height: 1;
            margin-top: 20PX;
            color: #242933;
            font-family: 'font-HYQH-65S';
            &.center{
                text-align: center;
            }
        }
        ul{
            position: relative;
            display: flex;
            &.center{
                // justify-content: center;
                li{
                    padding-left: 10px;
                    padding-right: 10px;
                    &:first-child {
                        padding-left: 0;
                    }
                    @media screen and (max-width:768px){
                        padding-left: 10PX;
                        padding-right: 10PX;
                        &:first-child {
                            padding-left: 0;
                        }
                    }
                }
            }
            li{
                position: relative;
                padding-right: 20px;
                a,i{
                    position: relative;
                    display: flex;
                    width: 28PX;
                    height: 28PX;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                        transition: all 0.3s ease;
                    }
                    &:hover{
                        img{
                            opacity: 0.5;
                            @media screen and (max-width:768px){
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
